import { 
    collection, 
    addDoc, 
    updateDoc, 
    deleteDoc, 
    doc, 
    getDoc, 
    getDocs,
    query,
    where,
    orderBy
} from 'firebase/firestore';
import { db } from './config';

export const addDocument = async (collectionName, data) => {
try {
    const docRef = await addDoc(collection(db, collectionName), {
    ...data,
    createdAt: new Date().toISOString()
    });
    return docRef.id;
} catch (error) {
    throw error;
}
};

export const updateDocument = async (collectionName, docId, data) => {
try {
    const docRef = doc(db, collectionName, docId);
    await updateDoc(docRef, {
    ...data,
    updatedAt: new Date().toISOString()
    });
} catch (error) {
    throw error;
}
};

export const deleteDocument = async (collectionName, docId) => {
try {
    const docRef = doc(db, collectionName, docId);
    await deleteDoc(docRef);
} catch (error) {
    throw error;
}
};

export const getDocument = async (collectionName, docId) => {
try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
} catch (error) {
    throw error;
}
};

export const getDocuments = async (collectionName, conditions = []) => {
try {
    const constraints = [];
    
    conditions.forEach(condition => {
    if (condition.type === 'where') {
        constraints.push(where(condition.field, condition.operator, condition.value));
    } else if (condition.type === 'orderBy') {
        constraints.push(orderBy(condition.field, condition.direction));
    }
    });

    const q = query(collection(db, collectionName), ...constraints);
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
    }));
} catch (error) {
    throw error;
}
};